import { Link } from "react-router-dom";
import GleverLogo from "@/components/GleverLogo";

const columns = [
  {
    title: "Product",
    links: [
      { label: "Pricing", to: "/pricing" },
      { label: "Growth Advisor", href: "#product" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/terms" },
      { label: "Privacy Policy", to: "/privacy" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Twitter / X", href: "https://twitter.com" },
      { label: "LinkedIn", href: "https://linkedin.com" },
    ],
  },
];

export function LandingFooter() {
  return (
    <footer className="bg-[hsl(222_47%_4%)] border-t border-white/[0.06] px-5 sm:px-8 md:px-10 py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <GleverLogo className="h-5 w-auto mb-3" alt="Growth Lever" />
            <p className="text-xs text-white/30 leading-relaxed max-w-[200px]">
              Campaign orchestration, embedded capital, and data-driven growth for performance marketers.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-4">
                {col.title}
              </p>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {"to" in link && link.to ? (
                      <Link
                        to={link.to}
                        className="text-sm text-white/35 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white/35 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/[0.06] pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/25">
            © 2026 Growth Lever. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/terms" className="text-xs text-white/25 hover:text-white/50 transition-colors">Terms</Link>
            <Link to="/privacy" className="text-xs text-white/25 hover:text-white/50 transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
